import React from 'react';
import { Link } from 'react-router-dom';
const CONTACT_EMAIL = 'info@beatsoda.com';
const INSTAGRAM_URL = 'https://www.instagram.com/beatyourbest_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
export function ShopFooter() {
  return <footer className="border-t border-white/10 px-5 py-10 md:px-10" data-id="element-291" data-mp="fp23jko6nyzu">
      <div className="mx-auto flex max-w-[1200px] flex-col gap-4 text-sm text-white/45 md:flex-row md:items-center md:justify-between" data-id="element-292" data-mp="atd199ks43zu">
        <div className="flex flex-wrap items-center gap-6" data-id="element-293" data-mp="3j5in2lxxin0l">
          <Link to="/" className="transition-colors duration-150 hover:text-white" data-id="element-294" data-mp="3ea39zw7qwv58">
            The brand
          </Link>
          <Link to="/shop" className="transition-colors duration-150 hover:text-white" data-id="element-295" data-mp="3o780u9cjdesd">
            Shop
          </Link>
          <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-150 hover:text-white" data-id="element-296" data-mp="30fj1wa57ls2g">
            {CONTACT_EMAIL}
          </a>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 hover:text-white" data-id="element-297" data-mp="jfhsarvr8fne">
            Instagram
          </a>
        </div>
        <p data-id="element-298" data-mp="x7o6w9j9eekq">
          Payments and delivery handled securely at checkout. ©{' '}
          {new Date().getFullYear()} BEAT Soda
        </p>
      </div>
    </footer>;
}